import { FunctionComponent } from 'react'

import { GlobalStyle } from '@medable/medable-web-ui'
import '@medable/nucleus-icon/index.css'

import { Router } from '@/components/router'
import { AppWrapper } from '@/components/app-wrapper'
import { NotificationWrapper } from '@/components/notification-wrapper'

const App: FunctionComponent = () => (
  <AppWrapper>
    <NotificationWrapper />
    <GlobalStyle />
    <Router />
  </AppWrapper>
)

export default App
